
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-6d18a5a4\",\"scoped\":true,\"hasInlineConfig\":false}!./style.css")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./script.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6d18a5a4\"}!./template.html"),
  /* scopeId */
  "data-v-6d18a5a4",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/PaymentService/index.vue
// module id = 77
// module chunks = 0